export default {
  // 禁止鼠标滚动时，输入框数据改变（针对[input=number]）
  inserted(el) {
    const input = el.tagName === 'INPUT' ? el : el.querySelector('input')
    input.addEventListener('mousewheel', e => {
      e.preventDefault()
    })
  }
}
